import CertificateRoute from './CertificateRoute';

export default {
  name: 'Certificate Management',
  location: '/certificates',
  component: CertificateRoute,
};
